// extracted by mini-css-extract-plugin
export var footer = "_nu-5";
export var fulfillmentInput = "_nu-0";
export var shipDateInput = "_nu-1";
export var shipmentModal = "_nu-2";
export var shipmentModalContent = "_nu-3";
export var tableContainer = "_nu-4";